<template>
  <div>
  <footer class="page-footer body-footer">

    <div class="row">
      <div class="col s12 m6 l6">
        <div class="row col-footer-margin">
          <h5 class="white-text bloock-footer">Powered by</h5>
        </div>

        <div class="row col-footer-margin">
          <div class="logo"><img class="responsive-img" src="/img/logo_sino.png" alt="Logo SiNo Servizi"></div>
          <div class='text'>{{ this.translation.getters.traduzione('ipartner.text') }}</div>

        </div>

      </div>

      <div class="col s12 m3 l3">

        <div class="row col-footer-margin">
          <h5 class="white-text bloock-footer"><i class="fas fa-gem me-3"></i>I GOT U</h5>
        </div>

        <div class="row col-footer-margin">
          <ul>

          <li><router-link :exact-active-class="'main-link-active'" class="nav-link main-link footer-link"
              to="/privacy">{{ this.translation.getters.traduzione('item.link.privacy') }}</router-link></li>

          <li><router-link :exact-active-class="'main-link-active'" class="nav-link main-link footer-link"
              to="/terms">{{ this.translation.getters.traduzione('item.link.terms') }}</router-link></li>

              <li><router-link :exact-active-class="'main-link-active'" class="nav-link main-link footer-link"
              to="/cookies-policies">{{ this.translation.getters.traduzione('item.link.coockie') }}</router-link></li>

        </ul>

        </div>

      </div>

      <div class="col s12 m3 l3">
        <div class="row col-footer-margin">
          <h5 class="white-text bloock-footer"><i class="fas fa-gem me-3"></i>{{ this.translation.getters.traduzione('follow.as') }}</h5>
        </div>

        <div class="row col-footer-margin">
          <a href="https://www.facebook.com/socialIGotU" target="_blank" class="icon-social">
                <img src="img/facebook.png" title="Si No Servizi" alt="Si No Servizi" />
              </a>

              <a href="https://www.instagram.com/sinoservizi/" target="_blank" class="icon-social">
                <img src="img/instagram.png" title="Si No Servizi" alt="Si No Servizi" />
              </a>

        </div>
      </div>
    </div>

  </footer>
  <div class="footer-copyright">

      copyright ©2025 Sì NO servizi srl. All rights reserved | P.IVA 02723031205

    </div>

  </div>
</template>

<script>
import translationStore from '@/store/translations'

export default {
  name: 'app',
  data () {
    return {
      translation: translationStore
    }
  },
  components: {},
  methods: {},
  created () { }
}
</script>
<style>
.footer-copyright{
  background-color: black;
  text-align: center!important;
  color: #fff;
  font-size: 0.85em;
  margin-top: -20px!important;
      padding-top: 10px!important;
    padding-bottom: 10px!important;
}

</style>
